import fetchData from '@helpers/fetchData';

let cachedIsGuest: boolean | null = null;

interface SessionInfoResponse {
  isGuest: boolean;
  timeout: number;
  csrfTokenName: string;
  csrfTokenValue: string;
  id: number | null | undefined;
  uid: string | null | undefined;
  username: string | null | undefined;
  email: string | null | undefined;
}

export async function fetchUserGuest(): Promise<boolean> {
  if (cachedIsGuest === null) {
    cachedIsGuest = await fetchData<SessionInfoResponse>('/actions/users/session-info').then(
      (response) => response.isGuest,
    );
  }

  return cachedIsGuest!;
}
